<template>
  <v-dialog scrollable content-class="custom-dialog" ref="dlgKelas" v-model="dialog" retain-focus max-width="750">
    <template v-slot:activator="{}"></template>

    <v-card>
      <v-card-title class="primary title white--text">
        <span style="word-break: break-word;">Pendaftaran Tryout</span>
      </v-card-title>

      <v-card-text class="my-0 py-0">
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="mb-0 pb-0">
            <v-alert icon="mdi-file-document-edit" class="mx-1" dense text type="info">
              <template>
                <p class="title black--text mb-0">Jadwal Tryout Tahap {{ tahap }}</p>
                <p class="black--text">
                  Berikut adalah jadwal pelaksanaan <i>tryout</i> seri Tahap {{ tahap }}. Dengan mendaftar, Anda akan mendapatkan jadwal <i>Tryout</i> secara otomatis dari sistem
                  berdasarkan jadwal yang masih tersedia.
                </p>
              </template>
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pb-4 py-0 mr-4">
        <v-row no-gutters>
          <v-col cols="12">
            <v-checkbox
              v-model="setuju"
              class="mx-2"
              dense
              color="info"
              name="setuju"
              label=""
              data-vv-name="setuju"
              data-vv-as="Persetujuan"
              v-validate="'required'"
              :error-messages="errors.collect('form.setuju')"
            >
              <template v-slot:label>
                <div class="body-2 info--text">Anda tidak dapat mengubah mata pelajaran setelah mendaftar salah satu tahap <i>tryout</i></div>
              </template>
            </v-checkbox>
          </v-col>
          <v-col cols="12" align="right">
            <m-button
              class="mx-1"
              color="grey"
              outlined
              :small="$vuetify.breakpoint.smAndDown ? true : false"
              textButton="Batal"
              icon=""
              action="tutup"
              @tutup="dialog = false"
            ></m-button>
            <m-button
              :disabled="!setuju"
              class="mx-1"
              :small="$vuetify.breakpoint.smAndDown ? true : false"
              textButton="Daftar"
              icon=""
              action="pilihKelas"
              @pilihKelas="daftarKelas()"
            ></m-button>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      mapel: null,
      setuju: false,
      edit: false,
      dialog: false,
      resolve: null,
      reject: null,
      kelasganjil: null,
      kelasgenap: null,
      jadwalTryouts: [],
      tahap: 1
    };
  },
  methods: {
    // eslint-disable-next-line
    open(mapel, tahap) {
      this.setuju = false;
      this.tahap = tahap;
      this.mapel = mapel;
      this.kelasganjil = null;
      this.kelasgenap = null;
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },

    daftarKelas() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          this.$store.commit("main/pStart");

          return this.$store
            .dispatch("kelas/enrollTryout", {
              model: "pilih",
              params: {
                mapel_id: this.mapel.mapel.id,
                tahap_id: this.tahap
              }
            })
            .then(res => {
              this.$store.commit("main/pEnd");
              this.$info("Anda berhasil mendaftar tryout Tahap " + this.tahap);
              this.dialog = false;
              this.edit = false;
              return this.resolve(res);
            })
            .catch(() => {
              this.$store.commit("main/pEnd");
            });
        });
    }
  },
  watch: {
    dialog(n) {
      if (!n && this.reject) {
        this.reject(null);
      }
    }
  }
};
</script>
<style>
.custom-dialog {
  -webkit-box-shadow: 0px 0px 2px 2px rgb(231, 230, 230);
}
</style>
